import { Component, Injector } from '@angular/core';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';


@Component({
  selector: 'app-currencies-list',
  templateUrl: './currencies-list.component.html',
  styles: []
})
export class CurrenciesListComponent extends GenericListComponent {
  constructor(public injector: Injector) {
    super(injector);
  }
}

